import { render, staticRenderFns } from "./UnpaidPayments.vue?vue&type=template&id=5bbc43e7&scoped=true"
import script from "./UnpaidPayments.vue?vue&type=script&lang=js"
export * from "./UnpaidPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbc43e7",
  null
  
)

export default component.exports